// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
// Refs: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDgpbezBt-25fVY9U-zZlbzSlnTTKJnpWI",
  authDomain: "trendmicroaccount.firebaseapp.com",
  projectId: "trendmicroaccount",
  storageBucket: "trendmicroaccount.appspot.com",
  messagingSenderId: "196840191290",
  appId: "1:196840191290:web:f34d163c6b6152b8e00c03",
  measurementId: "G-VMKTH5R5QG"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = firebase.firestore();

export const signInFirebase = () => {

  return firebase.auth().signInAnonymously();
  // .then(() => {
  //   // Signed in..
  // })
  // .catch((error) => {
  //   const errorCode = error.code;
  //   const errorMessage = error.message;
  //   // ...
  // });
}

export default db;